/**
 * What `/` shows someone in no project: one centered card to create their
 * first, like Linear's "create a workspace", or ask a teammate to add them.
 * No name or account card, only a quiet Sign out (for the wrong account). Not
 * a projects page — once they have one, the sidebar's switcher is where
 * projects live.
 */

import { useState } from "react";
import { Logo } from "@/components/logo";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/ui/field";
import { Toaster } from "@/components/toaster";
import { useLogout } from "@/features/auth/hooks";
import { useUserAdminAccess } from "@/features/users/hooks";
import { useCreateAndOpen } from "./new-project-dialog";
import { Centered } from "./project-gate";

export function FirstProject() {
  const [name, setName] = useState("");
  const create = useCreateAndOpen();
  const logout = useLogout();
  const { canRead: admin } = useUserAdminAccess();
  return (
    <Centered>
      <form
        className="box flex w-full max-w-md flex-col gap-4 px-7 py-6"
        onSubmit={(e) => (e.preventDefault(), name.trim() && create.submit(name))}
      >
        <Logo size={32} />
        <div className="flex flex-col gap-1">
          <h1 className="text-[17px] font-semibold">Create your first project</h1>
          <p className="text-[13px] leading-relaxed text-muted">
            A project holds its own agents, datasets, evaluators and experiments. Create one, or ask a
            teammate to add you.
          </p>
        </div>
        <Field label="Project name" htmlFor="first-project-name" hint="For example “CXR triage”.">
          <input
            id="first-project-name"
            className="inp"
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Field>
        <Button type="submit" variant="primary" disabled={!name.trim() || create.pending}>
          Create project
        </Button>
        {/* Admins manage people without being in a project. */}
        {admin && (
          <p className="text-center text-[13px] text-muted">
            Here to manage people?{" "}
            <a className="link" href="/users">
              Open Users
            </a>
          </p>
        )}
        <button
          type="button"
          className="self-center text-xs text-muted hover:text-ink disabled:opacity-40"
          onClick={() => logout.mutate()}
          disabled={logout.isPending}
        >
          Sign out
        </button>
      </form>
      <Toaster />
    </Centered>
  );
}
